<script>
  import {
    pop
  } from 'svelte-spa-router'
  export let invert
</script>

<div style="padding: 20px;">
<h2>Oh no! Something went wrong!</h2>
<a on:click={pop}><p class="invert">Go Back</p></a>
</div>
